(() => {
  const IMG_SELECTOR = '.complementary-product-card__img, .complementary-thumb__img';
  const PENDING_SELECTOR = '.complementary-product-card--pending, .complementary-thumb--pending';

  const getContainer = (img) => img.closest('.complementary-product-card, .complementary-thumb');

  const isReady = (container) =>
    container.classList.contains('complementary-product-card--ready') ||
    container.classList.contains('complementary-thumb--ready');

  const markReady = (container) => {
    if (!container || isReady(container)) return;

    requestAnimationFrame(() => {
      if (!container || isReady(container)) return;
      container.classList.remove('complementary-product-card--pending', 'complementary-thumb--pending');
      container.classList.add('complementary-product-card--ready', 'complementary-thumb--ready');
    });
  };

  const revealWhenReady = (img) => {
    const container = getContainer(img);
    if (!container || isReady(container)) return;

    const finish = () => markReady(container);

    if (img.complete && img.naturalWidth > 0) {
      finish();
      return;
    }

    img.addEventListener('load', finish, { once: true });
    img.addEventListener('error', finish, { once: true });
  };

  const scan = (root = document) => {
    root.querySelectorAll(PENDING_SELECTOR).forEach((container) => {
      const img = container.querySelector('img');
      if (!img) {
        markReady(container);
        return;
      }
      revealWhenReady(img);
    });
  };

  const boot = () => {
    scan();
    window.setTimeout(() => {
      document.querySelectorAll(PENDING_SELECTOR).forEach(markReady);
    }, 4000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('product-recommendations:loaded', () => scan());
})();
